<template lang="pug">
  v-card(color="teal lighten-4" width="100%")
    v-card-title
      h1.subheading.font-weight-regular Cancel Customers
    v-card-text.pt-0
      v-layout(row wrap)
        v-flex
          v-card.border-r-0(min-height="130px")
            v-card-text(style="height: 128px;")
              v-layout(align-center justify-center column fill-height)
                v-progress-circular(v-if="isLoading" size="70" width="7" indeterminate)
                animated-number.display-1.font-weight-light(v-if="!isLoading" :value="totalCancelCustomer.thisMonth" :formatValue="formatToNumber" :duration="1000")
                div.text-xs-center.caption.font-weight-regular.green--text Total Current Month
            v-card-actions
              v-card(color="teal lighten-4" width="100%")
                v-card-text
                  v-layout(align-center justify-center row fill-height)
                    div.text-xs-center.caption(v-if="totalCancelCustomer.prevoiuseMonth > totalCancelCustomer.thisMonth")
                      v-icon(small color="red") arrow_downward
                      span {{getCancelPercentage}}% Decreases
                      span ({{totalCancelCustomer.prevoiuseMonth}})
                    div.text-xs-center.caption(v-else)
                      v-icon(small color="green") arrow_upward
                      span {{getCancelPercentage}}% Increases
                      span ({{totalCancelCustomer.prevoiuseMonth}})
        v-flex
          v-card.border-r-0(min-height="130px")
            v-card-text(style="height: 128px;")
              v-layout(align-center justify-center column fill-height)
                v-progress-circular(v-if="isLoading" size="70" width="7" indeterminate)
                animated-number.display-1.font-weight-light(v-if="!isLoading" :value="sameMonthCancelCustomer.thisMonth" :formatValue="formatToNumber" :duration="1000")
                div.text-xs-center.caption.font-weight-regular.green--text Same Month Created
            v-card-actions
              v-card(color="teal lighten-4" width="100%")
                v-card-text
                  v-layout(align-center justify-center row fill-height)
                    div.text-xs-center.caption(v-if="sameMonthCancelCustomer.prevoiuseMonth > sameMonthCancelCustomer.thisMonth")
                      v-icon(small color="red") arrow_downward
                      span {{getSameMonthCancelPercentage}}% Decrease
                      span ({{sameMonthCancelCustomer.prevoiuseMonth}})
                    div.text-xs-center.caption(v-else)
                      v-icon(small color="green") arrow_upward
                      span {{getSameMonthCancelPercentage}}% Increases
                      span ({{sameMonthCancelCustomer.prevoiuseMonth}})
</template>

<script>
import dashbaordService from '../../service.js'
import AnimatedNumber from "animated-number-vue";

export default {
  data() {
    return {
      totalCancelCustomer: {
        thisMonth: 0,
        prevoiuseMonth: 0,
      },
      sameMonthCancelCustomer: {
        thisMonth: 0,
        prevoiuseMonth: 0,
      },
      isLoading: true
    }
  },
  components: {
    AnimatedNumber
  },
  computed: {
    getCancelPercentage() {
      var value = this.totalCancelCustomer.thisMonth - this.totalCancelCustomer.prevoiuseMonth
      if (value !== 0) {
        console.log('value / this.totalCancelCustomer.prevoiuseMonth * 100  ', (this.totalCancelCustomer.prevoiuseMonth ))
        return ((value / this.totalCancelCustomer.prevoiuseMonth * 100).toFixed(0))
      } else {
        return 0
      }
    },
    getSameMonthCancelPercentage() {
      var value = this.sameMonthCancelCustomer.thisMonth - this.sameMonthCancelCustomer.prevoiuseMonth
      if (value !== 0) {
        console.log('(value / this.sameMonthCancelCustomer.prevoiuseMonth * 100)  ', (value / this.sameMonthCancelCustomer.prevoiuseMonth * 100))
        return ((value / this.sameMonthCancelCustomer.prevoiuseMonth * 100).toFixed(0))
      } else {
        return 0
      }
    }
  },
  async mounted() {
    await this.getCancelCurrentMonth()
    await this.getCancelPreviousMonth()

    await this.getSameCancelCurrentMonth()
    await this.getPrevoiuseSameMonthCancellation()

    this.isLoading = false
  },
  methods: {
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getCancelCurrentMonth() {
      dashbaordService.getCancelCurrentMonth({month: 'current'})
      .then(result => {
        this.totalCancelCustomer.thisMonth = result.data.count
        
      })
    },
    getCancelPreviousMonth() {
      dashbaordService.getCancelPreviousMonth({month: 'previous'})
      .then(result => {
        this.totalCancelCustomer.prevoiuseMonth = result.data.count
      })
    },
    getSameCancelCurrentMonth() {
      dashbaordService.getCancelCurrentMonth({month: 'current', self: true})
      .then(result => {
        this.sameMonthCancelCustomer.thisMonth = result.data.count
      })
    },
    getPrevoiuseSameMonthCancellation() {
      dashbaordService.getCancelPreviousMonth({month: 'previous', self: true})
      .then(result => {
        // console.log('dasdf', result)
        this.sameMonthCancelCustomer.prevoiuseMonth = result.data.count
      })
    },
  }
}
</script>

<style scoped>
</style>